import {
  type InferOutput,
  literal,
  maxLength,
  nonEmpty,
  object,
  picklist,
  pipe,
  regex,
  string,
  trim,
  url,
  variant,
} from "valibot";

import { LINKEDIN_POST_URL_REGEX } from "./constants";

export const CreateListSchema = object({
  name: pipe(
    string(),
    trim(),
    nonEmpty("List name is required"),
    maxLength(45, "List name can't be more than 45 characters long"),
  ),
});
export type CreateListSchemaType = InferOutput<typeof CreateListSchema>;

export const CreateVariableSchema = object({
  name: pipe(
    string(),
    trim(),
    nonEmpty("Variable name is required"),
    maxLength(45, "Variable name can't be more than 45 characters long"),
  ),
});
export type CreateVariableSchemaType = InferOutput<typeof CreateVariableSchema>;

const crmSourceIdPipe = pipe(string(), nonEmpty("Source is required"));

// The main identifier (LinkedIn URL variable) is only required for EmailBison.
// It's validated per variant instead of with a forwarded check on the object, so
// it's reported alongside the other field errors rather than after they pass.
export const CrmSourceSchema = variant(
  "sourceType",
  [
    object({
      sourceType: literal("emailbison"),
      sourceId: crmSourceIdPipe,
      mainIdentifier: pipe(
        string(),
        trim(),
        nonEmpty("Variable name is required"),
      ),
    }),
    object({
      sourceType: picklist(["instantly", "smartlead"]),
      sourceId: crmSourceIdPipe,
      mainIdentifier: string(),
    }),
  ],
  "CRM is required",
);
export type CrmSourceSchemaType = InferOutput<typeof CrmSourceSchema>;

export const LinkedInPostSchema = object({
  postUrl: pipe(
    string(),
    regex(LINKEDIN_POST_URL_REGEX, "Please enter a valid LinkedIn post URL."),
  ),
});

export const NavigatorUrlSchema = object({
  url: pipe(
    string(),
    trim(),
    nonEmpty("Sales Navigator Search URL is required"),
    url("Enter a valid URL format (e.g., https://www.linkedin.com/sales/...)"),
  ),
});

export const UrlTargetingSchema = object({
  url: pipe(
    string(),
    nonEmpty("URL is required"),
    regex(
      /^https?:\/\/(www\.)?linkedin\.com\/search\/(.*)\/(.*)\?/,
      "The URL must be a valid LinkedIn search URL",
    ),
  ),
});
